import { cn } from "@perceptron/utils/cn";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("bg-skeleton animate-pulse rounded-md", className)} data-testid="skeleton" {...props} />;
}

export { Skeleton };
